export type WorkspaceGitHubInstallation = {
  id: string;
  installationId: number;
  accountLogin: string;
  accountType: string;
  repositorySelection: string;
};

export function selectGitHubInstallationsForOrganization(
  workspaceInstallation: WorkspaceGitHubInstallation | null | undefined,
): {
  isLoading: boolean;
  hasLinkedInstallation: boolean;
  installations: WorkspaceGitHubInstallation[];
} {
  if (workspaceInstallation === undefined) {
    return {
      isLoading: true,
      hasLinkedInstallation: false,
      installations: [],
    };
  }

  if (workspaceInstallation === null) {
    return {
      isLoading: false,
      hasLinkedInstallation: false,
      installations: [],
    };
  }

  return {
    isLoading: false,
    hasLinkedInstallation: true,
    installations: [workspaceInstallation],
  };
}
